import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BackfillCodeCitationsMutationVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
  force?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type BackfillCodeCitationsMutation = { __typename?: 'mutation_root', backfill_code_citations?: { __typename?: 'BackfillCodeCitationsOutput', jurisdiction_name: string, before: number, after: number, rules_linked: number, protected_rules: number, unresolved?: Array<{ __typename?: 'UnresolvedCitation', citation: string, count: number }> | null } | null };


export const BackfillCodeCitationsDocument = gql`
    mutation backfillCodeCitations($jurisdictionId: uuid!, $force: Boolean) {
  backfill_code_citations(
    input: {jurisdiction_id: $jurisdictionId, force: $force}
  ) {
    jurisdiction_name
    before
    after
    rules_linked
    protected_rules
    unresolved {
      citation
      count
    }
  }
}
    `;
export type BackfillCodeCitationsMutationFn = Apollo.MutationFunction<BackfillCodeCitationsMutation, BackfillCodeCitationsMutationVariables>;

/**
 * __useBackfillCodeCitationsMutation__
 *
 * To run a mutation, you first call `useBackfillCodeCitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackfillCodeCitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backfillCodeCitationsMutation, { data, loading, error }] = useBackfillCodeCitationsMutation({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useBackfillCodeCitationsMutation(baseOptions?: Apollo.MutationHookOptions<BackfillCodeCitationsMutation, BackfillCodeCitationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackfillCodeCitationsMutation, BackfillCodeCitationsMutationVariables>(BackfillCodeCitationsDocument, options);
      }
export type BackfillCodeCitationsMutationHookResult = ReturnType<typeof useBackfillCodeCitationsMutation>;
export type BackfillCodeCitationsMutationResult = Apollo.MutationResult<BackfillCodeCitationsMutation>;
export type BackfillCodeCitationsMutationOptions = Apollo.BaseMutationOptions<BackfillCodeCitationsMutation, BackfillCodeCitationsMutationVariables>;